import { useState, useEffect, MutableRefObject } from "react";

// Hook for client dimension look-up
function useClientDimensions(ref: MutableRefObject<HTMLElement | null>) {
  const [dimension, setDimension] = useState<{
    width: number;
    height: number;
  }>();

  useEffect(() => {
    if (ref.current) {
      setDimension({
        width: ref.current.clientWidth,
        height: ref.current.clientHeight,
      });
    }
  }, [ref]);

  return {
    ref,
    dimension,
  };
}

export default useClientDimensions;
